<template>
  <div
    class="publicator-tab"
    v-loading="loader.visible || loader.accept_scroll || is_loading"
  >
    <div class="button-group" v-if="access">
      <Button
        buttonSize="big"
        buttonColor="darkBlue"
        buttonText="Опубликовать"
        :disabled="publicatorLoading"
        class="accept-button"
        @click="(is_visible.publicator_dialog = true), (status = 'new')"
      />
      <Button
        buttonSize="big"
        buttonColor="blue"
        buttonText="Связать с публикацией"
        @click="handleCommand('import')"
        class="accept-button"
      />
    </div>

    <div v-if="getPublishedVacancy?.length" class="publicator__list">
      <PublicatorRow
        v-for="(item, i) in getPublishedVacancy"
        :key="`${item.id.value}_${i}`"
        :index="i"
        :item="item"
        :access="access"
      />
    </div>
    <div class="publicator-tab--empty" v-if="!getPublishedVacancy?.length">
      <Alert text="Эта вакансия еще не публиковалась на работных сайтах" />
    </div>
    <PublicatorImportDialog
      v-if="is_visible.publicator_import_dialog"
      :is_visible="is_visible.publicator_import_dialog"
      @save-callback="checkLinkedVacancy"
      @reset-callback="closeDialog('publicator_import_dialog', null)"
    />
    <PublicatorDialog
      v-if="is_visible.publicator_dialog"
      :is_visible="is_visible.publicator_dialog"
      :data="fields"
      :selected-published-vacancy="selectedPublishedVacancy"
      @save-callback="savePublicatorForm"
      @reset-callback="closePublicatorDialog"
    />
    <PublicatorAuthDialog
      v-if="is_visible.publicator_auth_dialog"
      :is_visible="is_visible.publicator_auth_dialog"
      :selected-published-vacancy="selectedPublishedVacancy"
      @reset-callback="closeDialog('publicator_auth_dialog', null)"
    />
    <UTMListDialog
      v-if="is_visible.publicator_utm_list_dialog"
      :is_visible="is_visible.publicator_utm_list_dialog"
    />
    <UTMBindingDialog
      v-if="is_visible.publicator_utm_binding_dialog"
      :is_visible="is_visible.publicator_utm_binding_dialog"
    />
    <UTMCreationDialog
      v-if="is_visible.publicator_utm_creation_dialog"
      :is_visible="is_visible.publicator_utm_creation_dialog"
    />
    <Dialog
      v-if="is_visible.accept_import_dialog.display"
      :is_visible="is_visible.accept_import_dialog.display"
      title="Связать с новой вакансией?"
      width="480px"
      buttonCancelText="Отменить"
      buttonOkText="Связать с новой вакансией"
      buttonOkColor="transparent"
      buttonCancelColor="transparent"
      @ok-callback="searchVacancy(is_visible.accept_import_dialog.data.url)"
      @cancel-callback="closeAcceptDialog"
      :text="is_visible.accept_import_dialog.data.text"
    />
  </div>
</template>
<script>
import Button from 'Elements/Button/Button';
import { store } from '@/store';
import { mixin, errorMsg, update } from '@/utils/mixins';
import { getController } from '@/controllers/request.js';
import Alert from 'Elements/Alert/Alert';
import PublicatorRow from 'Elements/Publicator/PublicatorRow';
import PublicatorDialog from 'Elements/Dialog/PublicatorDialog';
import PublicatorImportDialog from 'Elements/Dialog/PublicatorImportDialog';
import PublicatorAuthDialog from 'Elements/Dialog/PublicatorAuthDialog';
import UTMListDialog from 'Elements/Dialog/UTMListDialog';
import UTMBindingDialog from 'Elements/Dialog/UTMBindingDialog';
import UTMCreationDialog from 'Elements/Dialog/UTMCreationDialog';
import Dialog from 'Elements/Dialog/Dialog';

export default {
  mixins: [mixin, errorMsg, update],
  components: {
    PublicatorImportDialog,
    PublicatorRow,
    PublicatorDialog,
    PublicatorAuthDialog,
    UTMListDialog,
    UTMBindingDialog,
    UTMCreationDialog,
    Button,
    Alert,
    Dialog
  },
  data() {
    return {
      audit_iteration: 0,
      loader: {
        visible: true,
        accept_scroll: true
      },
      module: '',
      id: '',
      userId: store.state.common.userId,
      status: '',
      access: null
    };
  },
  async created() {
    this.module = this.$route.meta.module;
    this.id = this.$route.params.id;
    store.commit('publicator/setFullWorkSiteList');
    store.dispatch('publicator/setSelectedPublishedVacancyAsync', null);
    store.dispatch('vacancy/getUserInviteAndRefuseText', this.userId);
    await store.dispatch('publicator/searchAllPublishVacancy', this.id);
    await this.checkPermission();
    await store.dispatch('publicator/checkAuth');

    if (this.id) {
      let item = {};
      item['vacancy_id'] = { value: this.id };
      store.commit('publicator/setVacancyItem', item);
    }

    this.$set(this.loader, 'visible', false);
    this.$set(this.loader, 'accept_scroll', false);
  },
  methods: {
    async closePublicatorDialog() {
      this.closeDialog('publicator_dialog', null);
      await store.dispatch('publicator/setSelectedPublishedVacancyAsync', null);
      await store.dispatch('publicator/checkAuth');
      store.commit('publicator/setFullWorkSiteList');
    },
    closeAcceptDialog() {
      store.commit('common/setVisibleDialog', {
        name: 'accept_import_dialog',
        val: { display: false, data: {} }
      });
    },
    checkLinkedVacancy(link) {
      store.dispatch('publicator/checkLinkedVacancy', link);
    },
    searchVacancy(link) {
      store.dispatch('publicator/checkLink', link);
      this.closeAcceptDialog();
    },
    savePublicatorForm() {
      // store.dispatch('publicator/searchAllPublishVacancy', this.id);
      this.closeDialog('publicator_dialog', null);
      this.$emit('reloadTab');
    },
    handleCommand(command) {
      switch (command) {
        case 'import':
          this.is_visible.publicator_import_dialog = true;
          break;
      }
    },
    checkPermission() {
      getController({
        url: `/index.php?module=HRPAC_PUBLISHED_VACANCY&to_pdf=true&action=checkPermission&vacancy_id=${this.fields.id.value}`
      })
        .then(resp => {
          if (resp?.data?.show_buttons) this.access = true;
          else this.access = false;
        })
        .catch(err => this.catchError(err, err, 'check publicator permission'));
    }
  },
  computed: {
    getPublishedVacancy() {
      return store.state.publicator.publishedVacancy;
    },
    selectedPublishedVacancy() {
      return store.state.publicator.selectedPublishedVacancy || null;
    },
    authorized() {
      return !!store.state.publicator.hhData;
    },
    fields() {
      return store.state.vacancy.fields;
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    is_loading() {
      return store.state.publicator.is_loading;
    },
    publicatorLoading() {
      return store.state.publicator.publicatorLoading;
    }
  },
  updated() {
    if (!this.getLoadingStatus) {
      this.$emit('set-loading', false);
    }
  }
};
</script>

<style scoped lang="scss">
.button-group {
  display: flex;
  gap: 16px;
}

.publicator-tab {
  background: $white;
  text-align: left;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  .button-group {
    display: flex;
    gap: 16px;
  }
}
</style>
